import "./styles.css";
import { useEffect } from "react";
import Wordle from "./Wordle.js";

export default function App() {
  return (
    <div className="App">
      <Wordle />
    </div>
  );
}
